<template>
  <div class="enterprise-list-page">
    <PageHeader icon="fas fa-file-medical-alt">
      <template #title>Template Laporan Lab</template>
      <template #subtitle>Atur parameter, satuan, dan nilai rujukan untuk setiap pemeriksaan</template>
      <template #actions><b-button variant="primary" @click="$router.push('/lab-procedure-2/add')"><i class="fas fa-plus"></i> Tambah Pemeriksaan</b-button></template>
    </PageHeader>

    <b-alert show variant="light">
      Template dibuat otomatis dari <strong>Pemeriksaan & Tarif</strong>. Saat template dipilih pada Input Hasil, kategori dan seluruh parameter di bawahnya ikut terisi otomatis.
    </b-alert>

    <Card><template #body>
      <div class="d-flex justify-content-end mb-3"><modern-search-input v-model="filter.name" fluid placeholder="Cari pemeriksaan" @keyup="filterByName" style="max-width:320px" /></div>
      <b-table responsive hover show-empty empty-text="Belum ada pemeriksaan. Tambahkan dari Pemeriksaan & Tarif." :items="items" :fields="fields">
        <template #cell(name)="row"><strong>{{ row.item.procedure_name || row.item.name }}</strong></template>
        <template #cell(parameter_count)="row">{{ (row.item.field_collection || []).length }}</template>
        <template #cell(status)="row"><b-badge :variant="row.item.is_ready ? 'success' : 'warning'">{{ row.item.is_ready ? 'Siap dipakai' : 'Belum ada parameter' }}</b-badge></template>
        <template #cell(actions)="row">
          <b-button size="sm" variant="primary" :disabled="!row.item.procedure_id" @click="$router.push(`/lab-procedure-2/edit-templates/${row.item.id}`)"><i class="fas fa-sliders-h"></i> Atur Parameter</b-button>
        </template>
      </b-table>
      <b-pagination v-if="totalRows" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" @change="pagination" />
    </template></Card>
  </div>
</template>

<script>
import Card from '@/view/content/Card.vue'
import { debouncer } from '@/core/modules/Helper.js'
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'

export default {
  components: { Card },
  data: () => ({ filter: { name: '' }, perPage: 20, currentPage: 1, totalRows: 0, items: [], fields: [
    { key: 'name', label: 'Pemeriksaan' }, { key: 'lab_category_name', label: 'Kategori' }, { key: 'parameter_count', label: 'Jumlah Parameter' }, { key: 'status', label: 'Status' }, { key: 'actions', label: 'Aksi' }
  ] }),
  methods: {
    async pagination() { const response = await module.paginate('lab-templates', `?page=${this.currentPage}&page_size=${this.perPage}&name=${encodeURIComponent(this.filter.name)}`); this.items = response.data; this.totalRows = response.meta.pagination.total },
    filterByName() { debouncer(() => { this.currentPage = 1; this.pagination() }, 400) }
  },
  mounted() { this.$store.dispatch(SET_BREADCRUMB, [{ title: 'Pemeriksaan Lab' }, { title: 'Template Laporan' }]); this.pagination() }
}
</script>
